import ParametersPanel from './ParametersPanel';
export default ParametersPanel;